// extracted by mini-css-extract-plugin
export default {"displayUser":"displayUser_displayUser__0F7YF"};